





















import { Vue } from "vue-property-decorator";

import Info from "@/views/invest/form/stadium_info.vue"
import Detail from "@/views/invest_log/info.vue"
import Reason from "@/views/invest_audit/reason.vue"
import Business from "@/views/invest_audit/business_info.vue"

export default Vue.extend({
  name: "BussinessAudit",
  components: { Info, Detail, Reason, Business },
  data() {
    return {
      id    : "",
      log_id: "",
      active: 1,
    }
  },
  methods: {
    detail() {
      this.$nextTick(() => {
        const detail = this.$refs.detail as any
        detail.open(this.log_id)
      })
    },
    submit(op: number) {
      console.log({ id: this.log_id, result: op, description: "审核通过！" })
      if (op == 1) {
        this.$confirm({
          title  : "确定审核通过？",
          content: "通过后，该信息内容将与球友端同步，请谨慎操作！",
          onOk   : () => {
            this.do_submit({ id: this.log_id, result: op, description: "审核通过！" })
          }
        })
      } else {
        const reason = this.$refs.reason as any
        reason.open(this.log_id)
      }
    },
    async do_submit(params: any) {
      const res = await this.$store.dispatch("invest_audit/submit", params);
      if (res.Code == 200) {
        this.$info({
          title  : "审核成功！",
          onOk   : () => {
            const business = this.$refs.business as any
            business.get_info()
            if (params.op == 0) {
              const reason = this.$refs.reason as any
              reason.close()
            }
          }
        })
      } else {
        this.$confirm({
          title : "审核失败，请重试！",
          okText: "重试",
          onOk  : () => this.do_submit(params),
        })
      }
    }
  },
  mounted() {
    const query = { ...this.$route.query };
    if (query.id != "") {
      this.id = query.id as string;
    }
    if (query.log_id != "") {
      this.log_id = query.log_id as string;
    }
  }
})

